import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import EnforcementUserCreateViewModel from "viewModels/enforcement/enforcementUsers/enforcementUserCreateViewModel";
import CreateView from "../../common/create";
import EnforcementUserForm from "./enforcementUserForm";

const EnforcementUserCreateView: ViewComponent<EnforcementUserCreateViewModel> = observer(({ vm }) => (
  <CreateView vm={vm} form={<EnforcementUserForm vm={vm} />} />
));

registerView(EnforcementUserCreateView, EnforcementUserCreateViewModel);
